module.exports = __webpack_public_path__ + "static/media/pulmonology-image-new-1.8b9f5a58.png";